import React from 'react';

import { Flex } from 'antd-v5';

import MBImage from '../../mbcDashboard/components/MBImage';
import type { MBClass } from '../types';
import styles from './ClassEntry.module.scss';

const BADGE_SIZE = {
  sm: styles.badgeSm,
  md: styles.badgeMd,
  lg: styles.badgeLg,
};

interface MBClassLabelProps {
  mbClass: MBClass;
  size: keyof typeof BADGE_SIZE;
  children?: React.ReactNode;
}

export default function MBClassLabel(props: MBClassLabelProps) {
  const { mbClass, size, children } = props;

  return (
    <Flex align="center" gap="small">
      <MBImage
        src={mbClass.imageUrl100}
        alt={mbClass.meritBadgeName}
        className={BADGE_SIZE[size]}
      />
      {children ?? <span>{mbClass.label}</span>}
    </Flex>
  );
}
